module.exports = __webpack_public_path__ + "img/vuemov-default.ac9eca76.jpg";